var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-img',{attrs:{"src":_vm.src,"aspect-ratio":"1","max-height":"100","contain":"","alt":"client logo"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }